module.exports = __webpack_public_path__ + "media/assets/images/typhoon-abf5bcda2e576bc7a008fb13e3e19c60.png";